<div
  *ngIf="highlight"
  class="overflow-hidden shadow-lg cursor-pointer h-full"
  (click)="onTeaserClick(highlight)"
>
  <div class="relative w-full h-full">
    <img
      [src]="highlight.banner.url"
      [alt]="'Highlight Event - ' + highlight.eventType"
      class="w-full h-full object-contain block"
    />
    <div
      class="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 rounded-full p-2 shadow-lg"
    >
      <svg
        class="w-6 h-6 text-gray-800"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 5l7 7-7 7"
        ></path>
      </svg>
    </div>
  </div>
</div>
